(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/account-selector/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/syndicate/account-selector/assets/javascripts/init.js');

(function(svs, _) {
  'use strict';

  svs.syndicate.account_selector.logger = svs.core.log.getLogger('component:account-selector');

  svs.syndicate.AccountSelector = (function() {
    var syndicateCollection;
    var currentUserAccountModel = new svs.syndicate.account_selector.models.Account();
    var userAccountModel = new svs.syndicate.account_selector.models.Account();
    var hasFetchedBalance = false;
    var betslipFooterSyndicate;
    var modalHeaderClass = 'bg-grey-600';
    var gameClass;

    setup();

    function setup() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        syndicateCollection = new svs.syndicate.account_selector.collections.Syndicates([]);

        if (svs.syndicate.account_selector.data.syndicates && svs.syndicate.account_selector.data.syndicates.length) {
          syndicateCollection.reset(svs.syndicate.account_selector.data.syndicates, { parse: true });
          onCollectionSynced();
        } else {
          syndicateCollection.once('sync', onCollectionSynced);
          syndicateCollection.fetch();
        }
      }
    }

    function appendTo(element) {
      if (syndicateCollection && syndicateCollection.length > 0) {
        if (currentUserAccountModel.get('isSyndicate')) {
          currentUserAccountModel.trigger('change', currentUserAccountModel);
          if (syndicateCollection.length) {
            var syndModel = syndicateCollection.findWhere({ syndicateId: currentUserAccountModel.get('syndicateId') });
            if (syndModel) {
              syndModel.set('playableAmount', currentUserAccountModel.get('playableAmount'));
            }
          }
        }
        var el = element;
        el = el instanceof jQuery ? el : $(el);
        if (el.find('.js-account-selector-btn').length === 0) {
          el.append(svs.syndicate.account_selector.templates.account_selector_btn());
          el.on('click', '.js-account-selector-btn', function() {
            openAccountSelectModal();
          });
        }
      }
    }

    function onCollectionSynced(models) {
      if (svs.utils.ns.isNamespace('svs.utils.url.queryString.syndicateId')) {
        var syndicateId = parseInt(svs.utils.url.queryString.syndicateId, 10);

        if (!isNaN(syndicateId) && (models || svs.utils.ns.isNamespace('svs.syndicate.account_selector.data.syndicates'))) {
          try {
            var syndicate = syndicateCollection.where({ syndicateId: syndicateId, syndicateState: svs.syndicate.core.data.constants.syndicateState.ACTIVE });

            if (syndicate.length > 0) {
              currentUserAccountModel.setSyndicate(syndicate[0]);
            } else {
              setQueryString();
            }
          } catch (e) {
            svs.syndicate.account_selector.logger.debug('Did not find syndicate with id ' + syndicateId + ', Error: ' + e);
            currentUserAccountModel.setUser(userAccountModel.get('playableAmount'));
          }
        }
      }
      updateFooterTab();
      _.defer(checkRulesAndTerms);
    }
    function checkRulesAndTerms() {
      function displayTermDialog() {
        svs.syndicate.core.showSyndicateTermsDialog(function() {
          return true;
        });
      }
      if (svs.utils.ns.isNamespace('svs.syndicate.account_selector.data.canPlayAsSyndicate') && svs.syndicate.account_selector.data.canPlayAsSyndicate && currentUserAccountModel.get('isSyndicate')) {
        svs.syndicate.core.collections.getSyndicateCollectionInstance().reset(svs.syndicate.account_selector.data.syndicates, {
          parse: true
        });

        displayTermDialog();
      }
    }
    function openAccountSelectModal(excludeUserAccount, modalTitle, showCancelBtn) {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        if (excludeUserAccount) {
          showModal(modalTitle, showCancelBtn, new Backbone.Model({ displayAccount: false }));
        } else if (hasFetchedBalance) {
          showModal(modalTitle, showCancelBtn, userAccountModel);
        } else {
          getUserModel(_.bind(showModal, this, modalTitle, showCancelBtn));
        }
      } else {
        svs.components.customer_login.login();
      }
    }

    function showModal(modalTitle, showCancelBtn, userModel) {
      svs.components.Modal.show(
        svs.syndicate.account_selector.views.AccountSelector,
        {
          collection: syndicateCollection,
          model: userModel
        },
        {
          headerClass: (modalHeaderClass || 'bg-grey-600') + ' syndicate-account-selector',
          title: modalTitle || 'Spela Tillsammans',
          leftButton: {
            text: 'Avbryt',
            visible: showCancelBtn,
            cssClass: gameClass
          },
          rightButton: {
            text: 'Klart',
            visible: true,
            callback: onModalClose,
            cssClass: gameClass
          }
        }
      );
    }

    function onModalClose() {
      if (this.selectedAccountId) {
        if (this.selectedAccountId === 'user') {
          currentUserAccountModel.setUser(userAccountModel.get('playableAmount'));
          setQueryString();
        } else {
          currentUserAccountModel.setSyndicate(syndicateCollection.where({ syndicateId: this.selectedAccountId })[0]);
          setQueryString(this.selectedAccountId);
          _.defer(checkRulesAndTerms);
        }
        updateFooterTab($('.betslip-wrapper'));
      }

      svs.components.Modal.hide();
    }

    function setQueryString(syndicateId) {
      svs.utils.paramHandler.remove({ key: 'syndicateId' });
      var additionalParameters = document.location.search.replace('?', '&');

      if (syndicateId) {
        var query = document.location.search;
        query.split('syndicateId=');
        history.replaceState({}, '', document.location.origin + document.location.pathname + '?syndicateId=' + syndicateId + additionalParameters);
      } else {
        history.replaceState({}, '', document.location.origin + document.location.pathname);
      }
    }

    function getUserModel(callback) {
      svs.components.account_balance.get(function(balance) {
        if (!currentUserAccountModel.get('isSyndicate')) {
          currentUserAccountModel.setUser(svs.utils.format.Currency(balance));
        }
        userAccountModel.setUser(svs.utils.format.Currency(balance));

        hasFetchedBalance = true;
        callback(userAccountModel);
      });
    }

    function updateFooterTab($el) {
      betslipFooterSyndicate = $('.betslip-footer-syndicate', $el);
      if (!betslipFooterSyndicate.length) {
        betslipFooterSyndicate = $('.betslip-footer-syndicate');
      }
      if (currentUserAccountModel.get('isSyndicate')) {
        betslipFooterSyndicate.removeClass('hide');
        betslipFooterSyndicate.find('.betslip-footer-syndicate-name').text(currentUserAccountModel.get('syndicateName'));
      } else {
        betslipFooterSyndicate.addClass('hide');
      }
      if ($('#betslip').hasClass('open')) {
        appendTo(svs.syndicate.AccountSelector.el);
      }
    }

    function updateUserBalance() {
      hasFetchedBalance = false;
      getUserModel($.noop);
    }

    function updateFooterAndQueryString() {
      updateFooterTab();
      setQueryString(currentUserAccountModel.get('syndicateId') || null);
    }

    function init(el, headerClass, gameDefinitionClass) {
      if (!el) {
        throw new Error('AccountSelector needs an element as argument.');
      }

      if (headerClass) {
        modalHeaderClass = headerClass;
      }

      if (gameDefinitionClass && typeof gameDefinitionClass === 'string') {
        switch (gameDefinitionClass) {
          case 'keno':
          case 'maltipset':
            gameClass = 'btn-transparent-default';
            break;
          default:
            gameClass = 'btn-transparent-inverted';
        }
      } else {
        gameClass = 'btn-transparent-inverted';
      }

      svs.syndicate.AccountSelector.el = el;
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        appendTo(el);
      }
    }

    return {
      setQueryString: setQueryString,
      initWithButton: init,
      updateFooterTab: updateFooterTab,
      updateUserBalance: updateUserBalance,
      getUserModel: getUserModel,
      showAccountSelectModal: function(modalTitle, callback, excludeUserAccount, showCancelBtn) {
        openAccountSelectModal(excludeUserAccount, modalTitle, showCancelBtn);
      },
      getActiveAccountId: function() {
        return currentUserAccountModel.get('syndicateId');
      },
      getAccountModel: function() {
        return currentUserAccountModel;
      },
      updateFooterAndQueryString: updateFooterAndQueryString,
      hasSyndicateInUrl: function() {
        return svs.utils.ns.isNamespace('svs.syndicate.account_selector.data.syndicates') && svs.utils.ns.isNamespace('svs.utils.url.queryString.syndicateId');
      }
    };
  })();
})(svs, _);


 })(window);